import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, MapPin, Clock } from 'lucide-react';
export function MonthlyPopup() {
  const upcomingPopups = [{
    label: 'September 15',
    vendor: 'Peruvian Ceviche',
    cuisine: 'Peruvian Cuisine • Chef Juan Carlos Pacheco',
    date: 'Tue Sept 15 • 6–8 PM',
    image: 'https://cdn.magicpatterns.com/uploads/mu7irZk1PATaqjonGcGABk/Community_Workshops_2026_(1).png',
    link: 'https://www.eventbrite.com/e/1998651203552?aff=oddtdtcreator'
  }, {
    label: 'September 22',
    vendor: 'Let\'s Make Granola',
    cuisine: 'Baking • Joey Bottary',
    date: 'Tue Sept 22 • 6–8 PM',
    image: 'https://cdn.magicpatterns.com/uploads/rSqJEGZCYrbrLFP2vzaGjx/Granola_Community_Workshop_2026.png',
    link: 'https://www.eventbrite.com/e/1998652586689?aff=oddtdtcreator'
  }, {
    label: 'September 29',
    vendor: 'How to make Risotto',
    cuisine: 'Italian • Chef Manuel Quintero',
    date: 'Tue Sept 29 • 6–8 PM',
    image: 'https://cdn.magicpatterns.com/uploads/vexgXYbiz9sauSa4eiDa7p/Risotto_Workshops2026.png',
    link: 'https://www.eventbrite.com/e/lets-make-risotto-with-chef-manuel-quintero-tickets-1999054550975'
  }];
  return <section id="popups" className="py-20 lg:py-32 bg-foodCream" data-id="element-129" data-mp="w6aroj1qg1y4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-130" data-mp="w83zi1o30s7p">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-131" data-mp="1tub3pagh4ijj">
          <h2 className="text-5xl md:text-6xl font-extrabold uppercase mb-4" data-id="element-132" data-mp="1f5ew1eibx7jg">
            September <span className="text-foodTomato" data-id="element-133" data-mp="2ckizt8lra8q8">Resident Chef</span>
          </h2>
          <p className="text-xl max-w-2xl font-medium" data-id="element-134" data-mp="2cmm2ot80bwcd">
            This September, we're thrilled to welcome back Chef Maurice of
            Bayview's legendary Papa Rudy's.
          </p>
        </motion.div>

        {/* Featured This Month */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-foodCard border-4 border-foodMaroon shadow-[8px_8px_0px_0px_#34302A] overflow-hidden mb-16 flex flex-col lg:flex-row" data-id="element-135" data-mp="avmw6a40vlxs">
          <div className="lg:w-2/5 relative bg-foodMaroon flex items-center justify-center border-b-4 lg:border-b-0 lg:border-r-4 border-foodMaroon overflow-hidden min-h-[24rem]" data-id="element-136" data-mp="3nda0hwnga6xl">
            <img src="https://cdn.magicpatterns.com/uploads/9AdbKxFqZhBJXohSYLki4m/IMG_0373_2.jpg" alt="Papa Rudy's Bar-B-Que Pit, Bayview — archival photograph" className="w-full h-full object-cover" data-id="element-137" data-mp="3ec2fuhdux4lz" />
          </div>
          <div className="lg:w-3/5 p-8 lg:p-12 flex flex-col justify-center" data-id="element-138" data-mp="1cjxop846mbcb">
            <div className="inline-flex w-fit items-center gap-2 bg-foodTomato text-white text-sm font-bold px-3 py-1 mb-4 border-2 border-foodMaroon rotate-[-2deg]" data-id="element-139" data-mp="2x3jdl62onj7r">
              RESIDENT CHEF • SEPTEMBER 2026
            </div>
            <h3 className="text-2xl font-extrabold uppercase mb-2 tracking-tight lg:whitespace-nowrap" data-id="element-140" data-mp="36unnvsheyfw9">
              Chef Maurice Steuben, Heir to the Smoker...
            </h3>
            <p className="font-display text-xl text-foodMaroon/70 mb-6" data-id="element-141" data-mp="3frodu3k4sm1t">
              Papa Rudy's BBQ: A Bayview Legacy, Carried Forward by the Next
              Generation
            </p>
            <p className="mb-4 text-lg" data-id="element-142" data-mp="3pqx16dkhr2f7">
              Since 1993, Papa Rudy's BBQ has been more than a restaurant, it's
              been a cornerstone of San Francisco's Bayview community. Founded
              by Garland Steuben, Papa Rudy's built its name the old-fashioned
              way: low and slow, over real smoke, with recipes passed down and
              perfected over more than 30 years.
            </p>
            <p className="mb-4 text-lg" data-id="element-143" data-mp="hjgwtht531cw">
              Today, that legacy lives on through Garland's son, Chef Maurice
              Steuben, who has taken his father's vision and turned it into
              something even bigger. Under Chef Maurice, Papa Rudy's has evolved
              into a full-blown mobile operation, popping up all across the Bay
              Area.
            </p>
            <p className="mb-4 text-lg" data-id="element-144" data-mp="3uy3t5vq8cfxa">
              The menu is a love letter to tradition, reimagined for a new
              generation. Fall-off-the-bone pork ribs. Rich, smoky brisket.
              Chicken kissed by the smoker. And the homemade beef and hot links
              that have become a signature all their own. Alongside the meats
              sit the sides that make it a full soul food spread; creamy mac and
              cheese, sweet candied yams, slow-simmered collard greens, hearty
              potato salad, and baked beans done right. Oh, and their famous
              Rudy Punch.
            </p>
            <p className="mb-6 text-lg" data-id="element-145" data-mp="33or549p9gb2j">
              For over 30 years, Papa Rudy's hasn't just fed the Bayview, it's
              fed generations. And under Chef Maurice, the fire's burning
              brighter than ever, chasing the community instead of waiting for
              it to come knocking.
            </p>

            <div className="space-y-3 mb-8" data-id="element-146" data-mp="2pp9ctkcrafof">
              <div className="flex items-center gap-2 text-foodMaroon font-bold" data-id="element-147" data-mp="2pr2lt6audbzl">
                <Clock size={20} className="text-foodOrange shrink-0" data-id="element-148" data-mp="2kwq1ku1jjwms" />
                <span data-id="element-149" data-mp="2fyeswmmzfs65">Saturday & Sunday • 11 AM – 3 PM</span>
              </div>
              <div className="flex items-center gap-2 text-foodMaroon font-bold" data-id="element-150" data-mp="2bxuqp4njxyd5">
                <Calendar size={20} className="text-foodOrange shrink-0" data-id="element-151" data-mp="26yi7ctvw39fb" />
                <span data-id="element-152" data-mp="26xqehqtofpsq">All September long</span>
              </div>
              <div className="flex items-start gap-2 text-foodMaroon/80 font-medium" data-id="element-153" data-mp="220gfbjghjzrp">
                <MapPin size={20} className="shrink-0 mt-0.5 text-foodOrange" data-id="element-154" data-mp="1sbjhv4glep38" />
                <span data-id="element-155" data-mp="1xameq1mf5p04">
                  The Food Pavilion, India Basin Waterfront Park • 900 Innes
                  Ave, San Francisco, CA
                </span>
              </div>
            </div>

            <a href="https://drive.google.com/file/d/1HIjUonBL1QX1t2741TN4iw-zK5xD6Rgj/view?usp=drive_link" target="_blank" rel="noopener noreferrer" className="inline-block bg-foodTomato text-white font-bold text-lg py-4 px-8 border-2 border-foodMaroon shadow-[4px_4px_0px_0px_#34302A] hover:translate-y-[2px] hover:translate-x-[2px] hover:shadow-[2px_2px_0px_0px_#34302A] transition-all w-full sm:w-auto text-center" data-id="element-156" data-mp="1ncga3c98a4rk">
              Check Out the Menu
            </a>
          </div>
        </motion.div>

        {/* More This Month */}
        <div data-id="element-157" data-mp="2yserq4ih1z4e">
          <h3 className="text-3xl font-extrabold uppercase mb-8 flex items-center gap-4" data-id="element-158" data-mp="2ys53ald2s00t">
            Upcoming Community Experiences
            <div className="h-1 flex-grow bg-foodMaroon/10" data-id="element-159" data-mp="nb1t0d0irlwk"></div>
          </h3>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-160" data-mp="id0abt709olm">
            {upcomingPopups.map((popup, idx) => <motion.a key={idx} href={popup.link || undefined} target={popup.link ? '_blank' : undefined} rel={popup.link ? 'noopener noreferrer' : undefined} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="block bg-foodCard border-4 border-foodMaroon group cursor-pointer hover:-translate-y-2 transition-transform duration-300" data-id="element-161" data-mp="x266f8ajqypa" data-mpi={idx}>
                <div className="h-56 relative border-b-4 border-foodMaroon overflow-hidden bg-foodMaroon" data-id="element-162" data-mp="3ebix7qjo4w0k">
                  <img src={popup.image} alt={popup.vendor} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" data-id="element-163" data-mp="3j9ap4kkbci4r" />
                  <div className="absolute top-0 right-0 bg-foodMaroon text-foodCream font-bold px-4 py-2" data-id="element-164" data-mp="3t184m3ictw9a">
                    {popup.label}
                  </div>
                </div>
                <div className="p-6" data-id="element-165" data-mp="5tmhq267ih2n">
                  <p className="text-foodOrange font-bold text-sm mb-1" data-id="element-166" data-mp="auag58wrm06w">
                    {popup.date}
                  </p>
                  <h4 className="text-2xl font-extrabold uppercase mb-1" data-id="element-167" data-mp="ftn642ixnndp">
                    {popup.vendor}
                  </h4>
                  <p className="text-foodMaroon/70 font-medium" data-id="element-168" data-mp="2cn87f0aw8kpq">
                    {popup.cuisine}
                  </p>
                </div>
              </motion.a>)}
          </div>
        </div>
      </div>
    </section>;
}